import { render, staticRenderFns } from "./FilesDataTransfer.vue?vue&type=template&id=5c37aa9a&scoped=true"
import script from "./FilesDataTransfer.vue?vue&type=script&lang=js"
export * from "./FilesDataTransfer.vue?vue&type=script&lang=js"
import style0 from "./FilesDataTransfer.vue?vue&type=style&index=0&id=5c37aa9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37aa9a",
  null
  
)

export default component.exports